import { Scissors } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { EmptyState } from '@/components/ui/empty-state';

export function EditPage() {
  return (
    <div className="space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Video edit</h1>
        <p className="text-sm text-muted-foreground">
          Assembler workflow output — captions, overlays, slideshow assembly, talking-head edits.
          Plan 04 wires this in; the schema field <code>Content.assembly</code> is already
          present, so we'll backfill without a migration.
        </p>
      </header>

      <Card>
        <CardHeader>
          <CardTitle>Assembly jobs</CardTitle>
        </CardHeader>
        <CardContent>
          <EmptyState
            icon={<Scissors className="h-8 w-8" />}
            title="No assembly jobs yet"
            description="When the assembler workflow runs, each completed content piece picks up an Assembly record. The list will show job status, recipe, and output side-by-side with the original."
          />
        </CardContent>
      </Card>
    </div>
  );
}
